import React from "react";
import { SendOutlined, WhatsAppOutlined } from "@ant-design/icons";
import "./SupportContacts.css";

export default function SupportContacts({ className = "" }) {
  return (
    <section className={`support-block ${className}`.trim()}>
      <h2 className="support-block__title">Помощь</h2>
      <nav className="support-contacts" aria-label="Связаться с поддержкой">
        <a
          className="support-contact support-contact--whatsapp"
          href="https://wa.me/79285147009"
          target="_blank"
          rel="noreferrer"
          aria-label="Написать в WhatsApp"
          title="WhatsApp"
        >
          <WhatsAppOutlined />
        </a>
        <a
          className="support-contact support-contact--telegram"
          href="https://t.me/simolapps"
          target="_blank"
          rel="noreferrer"
          aria-label="Написать в Telegram"
          title="Telegram"
        >
          <SendOutlined />
        </a>
      </nav>
    </section>
  );
}
